var _effectorFileName = "/builds/gmini/front-common/src/Explorer/hooks/useOperations.tsx";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React from 'react';
import { race } from '@gmini/utils';
export function useCreate(_ref) {
  var onOpen = _ref.onOpen,
      folderCreated = _ref.folderCreated,
      entityCreated = _ref.entityCreated,
      assemblyCreated = _ref.assemblyCreated,
      onCreateEntity = _ref.onCreateEntity,
      onCreateAssembly = _ref.onCreateAssembly,
      onCreateFolder = _ref.onCreateFolder;
  var onCreate = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(props) {
      var name, parentFolderId;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              name = props.name, parentFolderId = props.parentCategoryId;
              _context.t0 = props.type;
              _context.next = _context.t0 === 'Category' ? 4 : _context.t0 === 'Entity' ? 7 : _context.t0 === 'Assembly' ? 13 : 20;
              break;

            case 4:
              _context.next = 6;
              return race(folderCreated.filter({
                fn: function fn(folder) {
                  return folder.name === name && folder.parentFolderId === parentFolderId;
                }
              }), onCreateFolder({
                name: name,
                parentFolderId: parentFolderId,
                projectUrn: props.projectUrn
              }));

            case 6:
              return _context.abrupt("return");

            case 7:
              _context.t1 = onOpen;
              _context.next = 10;
              return race(entityCreated.filter({
                fn: function fn(entity) {
                  return entity.name === name && entity.parentFolderId === parentFolderId;
                }
              }), onCreateEntity({
                name: name,
                parentFolderId: parentFolderId,
                projectUrn: props.projectUrn
              }));

            case 10:
              _context.t2 = _context.sent;
              (0, _context.t1)(_context.t2);
              return _context.abrupt("return");

            case 13:
              if (!(!assemblyCreated || !onCreateAssembly)) {
                _context.next = 15;
                break;
              }

              return _context.abrupt("return");

            case 15:
              _context.t3 = onOpen;
              _context.next = 18;
              return race(assemblyCreated.filter({
                fn: function fn(assembly) {
                  return assembly.name === name && assembly.parentFolderId === parentFolderId;
                }
              }), onCreateAssembly({
                name: name,
                parentFolderId: parentFolderId,
                projectUrn: props.projectUrn
              }));

            case 18:
              _context.t4 = _context.sent;
              (0, _context.t3)(_context.t4);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [entityCreated, folderCreated, assemblyCreated, onCreateAssembly, onCreateEntity, onCreateFolder, onOpen]);
  return {
    onCreate: onCreate
  };
}
export function useCopy(_ref3) {
  var getEntity = _ref3.getEntity,
      onCopyEntity = _ref3.onCopyEntity,
      onCopyAssembly = _ref3.onCopyAssembly,
      getAssembly = _ref3.getAssembly;
  var onCopy = React.useCallback(function (_ref4) {
    var id = _ref4.id,
        name = _ref4.name,
        type = _ref4.type;

    switch (type) {
      case 'Entity':
        {
          var entity = getEntity(id);

          if (!entity) {
            throw new ReferenceError("\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D ".concat(type, " \u0441 id ").concat(id));
          }

          return onCopyEntity({
            id: entity.id,
            version: entity.version,
            name: name
          });
          return;
        }

      case 'Assembly':
        {
          if (!getAssembly || !onCopyAssembly) {
            return;
          }

          var assembly = getAssembly(id);

          if (!assembly) {
            throw new ReferenceError("\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D ".concat(type, " \u0441 id ").concat(id));
          }

          return onCopyAssembly({
            id: assembly.id,
            version: assembly.version,
            name: name
          });
        }
    }
  }, [getAssembly, getEntity, onCopyAssembly, onCopyEntity]);
  return {
    onCopy: onCopy
  };
}
export function useRename(_ref5) {
  var onRenameEntity = _ref5.onRenameEntity,
      onRenameFolder = _ref5.onRenameFolder,
      onRenameAssembly = _ref5.onRenameAssembly;
  var onRename = React.useCallback(function (_ref6) {
    var id = _ref6.id,
        type = _ref6.type,
        name = _ref6.newName,
        version = _ref6.version,
        parentFolderId = _ref6.parentCategoryId;

    switch (type) {
      case 'Category':
        {
          return onRenameFolder({
            id: id,
            name: name,
            parentFolderId: parentFolderId
          });
        }

      case 'Entity':
        return onRenameEntity({
          id: id,
          name: name,
          parentFolderId: parentFolderId,
          version: version
        });

      case 'Assembly':
        if (onRenameAssembly) {
          return onRenameAssembly({
            id: id,
            name: name,
            parentFolderId: parentFolderId,
            version: version
          });
        }

    }
  }, [onRenameAssembly, onRenameEntity, onRenameFolder]);
  return {
    onRename: onRename
  };
}
export function useMove(_ref7) {
  var onMoveFolder = _ref7.onMoveFolder,
      onMoveEntity = _ref7.onMoveEntity,
      onMoveAssembly = _ref7.onMoveAssembly,
      fetch = _ref7.fetch;
  var onMove = React.useCallback( /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref8) {
      var id, type, parentFolderId, version;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              id = _ref8.id, type = _ref8.type, parentFolderId = _ref8.newParentCategoryId, version = _ref8.version;
              _context2.t0 = type;
              _context2.next = _context2.t0 === 'Category' ? 4 : _context2.t0 === 'Entity' ? 7 : _context2.t0 === 'Assembly' ? 10 : 15;
              break;

            case 4:
              _context2.next = 6;
              return onMoveFolder({
                id: id,
                parentFolderId: parentFolderId
              }).then(function () {
                // FSK-926 -  Стейдж. Сет-менеджмент. Папка перестает отображаться после перемещения из корня в другую папку
                if (parentFolderId) {
                  fetch({
                    id: parentFolderId
                  });
                }
              })["catch"](function () {
                return Promise.resolve();
              });

            case 6:
              return _context2.abrupt("break", 15);

            case 7:
              _context2.next = 9;
              return onMoveEntity({
                id: id,
                parentFolderId: parentFolderId,
                version: version
              }).then(function () {
                // FSK-926 -  Стейдж. Сет-менеджмент. Папка перестает отображаться после перемещения из корня в другую папку
                if (parentFolderId) {
                  fetch({
                    id: parentFolderId
                  });
                }
              })["catch"](function () {
                return Promise.resolve();
              });

            case 9:
              return _context2.abrupt("break", 15);

            case 10:
              if (onMoveAssembly) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt("return");

            case 12:
              _context2.next = 14;
              return onMoveAssembly({
                id: id,
                parentFolderId: parentFolderId,
                version: version
              }).then(function () {
                // FSK-926 -  Стейдж. Сет-менеджмент. Папка перестает отображаться после перемещения из корня в другую папку
                if (parentFolderId) {
                  fetch({
                    id: parentFolderId
                  });
                }
              })["catch"](function () {
                return Promise.resolve();
              });

            case 14:
              return _context2.abrupt("break", 15);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref9.apply(this, arguments);
    };
  }(), [fetch, onMoveAssembly, onMoveEntity, onMoveFolder]);
  return {
    onMove: onMove
  };
}
export function useRemove(_ref10) {
  var onRemoveEntity = _ref10.onRemoveEntity,
      onRemoveFolder = _ref10.onRemoveFolder,
      onRemoveAssembly = _ref10.onRemoveAssembly;
  var onRemove = React.useCallback(function (_ref11) {
    var id = _ref11.id,
        type = _ref11.type;

    switch (type) {
      case 'Category':
        return onRemoveFolder({
          id: id
        });

      case 'Entity':
        return onRemoveEntity({
          id: id
        });

      case 'Assembly':
        if (onRemoveAssembly) {
          return onRemoveAssembly({
            id: id
          });
        }

    }
  }, [onRemoveAssembly, onRemoveEntity, onRemoveFolder]);
  return {
    onRemove: onRemove
  };
}